module.exports = __webpack_public_path__ + "files/b8300d45505d00ae45fc5a1f8f26a4eb.png";